import React, { useEffect, useState } from 'react';
import * as moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { userComments } from 'redux/actions/customerReviews';
import { FORMAT } from 'web/components/utils/dateOfBirthValidation';
import AlertModal from 'web/components/AlertModal';
import Spinner from 'web/components/Spinner';
import Rating from '@material-ui/lab/Rating';
import Box from '@material-ui/core/Box';
import { Button, UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Container, Wrapper, SellerInfo, ActionSection, CustomerReview, ReviewBox } from './customerReviewsStyled'
import { MdKeyboardBackspace } from "react-icons/md";


const AdminCustomerReviews = (props) => {
    let history = useHistory();
    let location = useLocation();
    const dispatch = useDispatch();

    const [value, setValue] = React.useState(2);
    const [postType, setPostType] = React.useState('');
    const [response, setResponse] = React.useState();

    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('/');

    const [page, setPage] = useState(1);
    const [abusePage, setAbusePage] = useState(1);
    const [tabValue, setTabValue] = useState(0);

    const toggleModal = () => setModal(!modal);
    let title = '';

    const loaderVisible = useSelector(
        (state) => state.appReducer.loaderVisible
    );

    const token = localStorage.getItem('token');

    const fetchMyAPI = async (userId, postType) => {
        let userType;
        if (postType === "SELLER") {
            userType = "SELLER"
        } else {
            userType = "BUYER"
        }
        let response = await dispatch(userComments(userType, userId, token));
        if (response.status === "SUCCESS") {
            if (response.payload) {
                setResponse(response.payload)
            }
        } else {
            if (response.statusCode === 401) {
                history.push('./sign-in')
                window.location.reload(false);
            } else {
                setModalContent(response.message);
                setModalLink('');
                toggleModal();
            }
        }

    }

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search)
        fetchMyAPI(queryParams.get("userId"), queryParams.get("postType"))
    }, []);

    return (
        <div>
            {loaderVisible && <Spinner />}
            <Container>
                <MdKeyboardBackspace style={{ width: '28px', height: '28px', cursor: 'pointer' }}
                    onClick={() => {
                        history.push({
                            pathname: '/content-moderation',
                            state: { page: page, abusePage: abusePage, tabValue: tabValue }
                        })
                    }} />
                {response && <Wrapper>
                    <SellerInfo>
                        {response.address && <div>
                            <h3>{response.userType === 'BUYER' ? 'Buyer Info:' : 'Seller Info:'}</h3>
                            <h4>Name: {response.address.companyName}</h4>
                            <p>Address: {response.address.line1}&nbsp; {response.address.line2}</p>
                            <p style={{ position: 'relative', left: '68px' }}>{response.address.city}&nbsp; {response.address.state}&nbsp; {response.address.zip}</p>
                        </div>
                        }

                        <div>
                            <p className="favorite">Rating</p>
                            <div>
                                <Box component="fieldset" mb={3} borderColor="transparent">
                                    <Rating
                                        name="simple-controlled"
                                        value={response.rating && response.rating.rating}
                                        disabled
                                    />
                                </Box>
                            </div>
                            <ActionSection>
                                <Button id="PopoverFocus" type="button" style={{ zIndex: '1', background: 'none', color: '#2525ed', padding: '0', border: 'none' }}>
                                    {response.userType === 'BUYER' ? 'Contact Buyer' : 'Contact Seller'}
                                </Button>
                                <UncontrolledPopover trigger="legacy" placement="left" target="PopoverFocus">
                                    <PopoverHeader>Email</PopoverHeader>
                                    <PopoverBody>{response.comments && response.comments[0].postedToInfo.email}</PopoverBody>
                                </UncontrolledPopover>
                            </ActionSection>
                        </div>
                    </SellerInfo>
                    {response.comments !== 0 && response.countComments !== 0 && <CustomerReview>
                        <h5 style={{ padding: '10px' }} >Customer Reviews<span> ({response.countComments})</span></h5>
                        {response.comments.map((item, index) => (<ReviewBox key={index}>
                            <h3> Name: {item.postedByInfo.name}</h3>
                            <div><p>  Reviewed <span>{item.title}</span> on {moment(item.createdAt && item.createdAt).format(FORMAT)}</p></div>
                            <p style={{ wordBreak: "break-all" }}>Comments: {item.comment}</p>
                            <div style={{ display: "flex", marginTop: '4px' }}>
                                <p style={{ padding: "0px", margin: '0px 36px 0px 0px' }}>Rating</p>
                                <Box component="fieldset" mb={3} borderColor="transparent">
                                    <Rating
                                        name="simple-controlled"
                                        value={item.rating && item.rating}
                                        disabled
                                    />
                                </Box>
                            </div>
                        </ReviewBox>
                        ))}
                    </CustomerReview>
                    }
                </Wrapper>
                }
                <AlertModal
                    isOpen={modal}
                    toggle={toggleModal}
                    title={title}
                    content={modalContent}
                    link={modalLink}
                />
            </Container>
        </div>
    );
}
export default AdminCustomerReviews;
